import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import { makeStyles } from '@material-ui/core/styles';

import { formatParseObjSelectOptions } from '../../utils';
import FormField from '../../components/form/FormField';
import ReduxFormReactSelect from '../../components/reduxFormMUIWrapper/ReduxFormReactSelect';

const useStyles = makeStyles({
  root: {
    composes: 'flexColumn stretch center',
  },
  selectField: {
    width: 160,
  },
});

const ProductForm = (props) => {

  // props
  const { handleSubmit, templates } = props;
  
  // styles
  const classes = useStyles(props);

  return (
    <form className={classes.root} onSubmit={handleSubmit}>
      <FormField
        label='Templates'
        name='templates'
        fullWidth
        isMulti
        component={ReduxFormReactSelect}
        options={formatParseObjSelectOptions(templates)}
      />
      <input type='submit' />
    </form>
  );
};

ProductForm.propTypes = {
  onSubmit: PropTypes.func,
  resetForm: PropTypes.bool,
  templates: PropTypes.array,
};
export default reduxForm({
  form: 'productForm',
  enableReinitialize : true
})(ProductForm);
